import * as React from 'react';
import BaseAnimation from './BaseAnimation';

const FadeAnimation = (props: $TSFixMe) => {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const { children, fadeOut = true, className, duration = 400, setRef, onAnimationFinished = () => {} } = props;
    const style = {
        transitionProperty: 'opacity',
        transitionDuration: `${duration}ms`,
        opacity: fadeOut ? 0 : 1
    };

    return (
        // @ts-expect-error TS(2769): No overload matches this call.
        <BaseAnimation duration={duration} style={style} className={className} active={!fadeOut} setRef={setRef} onAnimationFinished={onAnimationFinished}>
            {children}
        </BaseAnimation>
    );
};

export default FadeAnimation;
